import { render, staticRenderFns } from "./BoxPhoto.vue?vue&type=template&id=016b5341&"
import script from "./BoxPhoto.vue?vue&type=script&lang=js&"
export * from "./BoxPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports